export default class helperFunctions {
  replaceSpecialCharacters(json, encodedVariable, replaceVariable) {
    let sanitisedJson = json.replace(encodedVariable, replaceVariable);

    return sanitisedJson;
  }
}
